/**
 * Sikmo — Main JavaScript Entry Point
 * Ported from old WP theme (Gulp/Webpack → Vite)
 */

// Import CSS (Vite bundles this into theme.css)
import '../css/style.css';

// IMPORT LIBRARIES
import { gsap } from "gsap";

// IMPORT STORE
import { generalStore } from "./components/GeneralStore.js";

// IMPORT DEPENDENCIES
import { Animations } from "./components/Animations.js";
import { Sliders2 } from "./components/Sliders2.js";
import { Services } from "./components/Services.js";
import { Video } from "./components/Video.js";
import { Functionalities } from "./components/Functionalities.js";
import { caseStudies } from "./components/caseStudies.js";
import { ServicesScroll } from "./components/ServicesScroll.js";
import { AOS } from "./components/AOS.js";

// IMPORT PLUGINS
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

// REGISTER GSAP PLUGINS
gsap.registerPlugin(ScrollTrigger);

// INIT FUNCTIONALITIES (nav, menu toggle, etc.)
new Functionalities();

// SET INSTANCES
const animations = new Animations();
const sliders2 = new Sliders2();
const services = new Services();
const video = new Video();
const servicesScroll = new ServicesScroll();

services.initServicesAnimations();

document.addEventListener("DOMContentLoaded", function () {
  // INIT SLIDERS
  sliders2.referencesSliderInit();
  sliders2.reviewsSliderInit();
  sliders2.teamSliderInit();
  sliders2.timelineSliderInit();

  // INIT ANIMATIONS
  animations.logoCloudsInfiniteScroll();
  animations.paralaxImage(".hero-image");
  animations.paralaxImage(".layer-back-wrapper");
  animations.paralaxImage(".layer-front-wrapper");
  animations.mouseMoveEffect(".mouse-move__footer");
  animations.mouseMoveEffect(".mouse-move__pricelist");
  animations.mouseMoveEffect(".layer-back");
  animations.mouseMoveEffect(".layer-front", 1);
  animations.mouseMoveEffect(".hero-image-wrapper", 0.5);

  animations.stickyPosition("logo-wrapper");
  animations.stickyPosition("nav-menu-wrapper");
  animations.stickyPosition("contact-us");

  video.initYoutubeVideo();

  setTimeout(() => {
    animations.animateStats();
    animations.animateVerticalStats();
  }, 1000);

  services.initCenterObserver();

  // INIT BLOCKS
  caseStudies.init();
  servicesScroll.init();

  // AOS-style reveal on scroll — runs last so initial gsap.set() states
  // aren't stomped by other setup.
  new AOS().init();
});
